<div id="carousel-example-2" class="carousel slide carousel-fade" data-ride="carousel">

    <div class="carousel-inner top-carousel" role="listbox">
        <div class="carousel-item active">
            <!-- 
            <div class="bannercontainer">
                <div class="captionser container">
                    <h1>We are there to take care of you</h1>
                    <h3>Proud to Care</h3>
                </div>
            </div> -->

            <picture>
                <source srcset="/assets/images/img/servicemobilebannerdesign.jpg" media="(max-width: 479px)">
                <source srcset="/assets/images/img/servicesimagebanner.jpg" media="(max-width: 4000px)">
                <source srcset="/assets/images/img/servicesimagebanner.jpg">
                <img src="/assets/images/img/servicesimagebanner.jpg" alt="First slide" style="width:100%;">
            </picture>
            <div class="mask rgba-black-light"></div>



        </div>

    </div>
</div>

<div class="container">
    <div class="wellcaremain">
        <h1>Well Care Services</h1>
    </div>
    <div class="wellcarepara">
        <p> Our medical team is equipped with the best available professionals to satisfy the short term and long term needs of our customers.
        </p>
    </div>

</div>


<div class="container">

    <div class="ourmain">
        <div class="col-lg-6 col-md-12 col-sm-12">
            <div class="ourmainhead">
                <h2>Our Caring Staff</h2>
            </div>
            <div class="ourmainpara">
                <p>We offer a range of professional, care services which are delivered by our compassionate and caring staff.</p>
                <p>All certified and experienced registered nurses and other healthcare professionals in our team are exceeding competent and experienced.</p>
                <p> Each and every one of our staff has undergone a competent and thorough training schedule to guarantee an epitome of service standard. </p>

                <p>Our medical team is equipped with the best available professionals to satisfy the short term and long term needs of our customers.
                </p>


            </div>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 careimgcontainer">
            <div class="careimgmain">
                <img class="careimg" src="/assets/images/img/services.jpg" alt="">
            </div>
        </div>
    </div>
</div>




<div class="whatwedosercontainer">
    <div class="whatwedosermain">
        <div class="whatwedoserred">
            <h2>What we do</h2>
        </div>

        <div class="whatwedoser-para">
            <p>Well Care offer a range of professional care services which are delivered by our compassionate and caring staff We specialize in nursing care and our agency spreads over Worcestershire, Herefordshire, and Gloucestershire. Our services include
                providing Nurses, Health Care assistants to Nursing and residential homes.</p>
        </div>
        <div class="whaticonser container">
            <div class=" iconser_holder ">
                <div>
                    <img style="width: 70%;" itemprop="image " class="smallser-icons " src="/assets/images/img/icon-1.png " alt=" ">
                    <div class="iconser-head">Customer First</div>
                </div>
            </div>
            <div class="iconser_holder ">
                <div>
                    <img style="width: 70%;" itemprop="image " class="smallser-icons " src="/assets/images/img/icon-2.png " alt=" ">
                    <div class="iconser-head">Our Professionalism</div>
                </div>
            </div>
            <div class="iconser_holder ">
                <div>
                    <img style="width: 70%;" itemprop="image " class="smallser-icons " src="/assets/images/img/icon-3.png " alt=" ">
                    <div class="iconser-head">24/7 Service</div>
                </div>
            </div>
            <div class="iconser_holder ">
                <div>
                    <img style="width: 70%;" itemprop="image " class="smallser-icons " src="/assets/images/img/icon-4.png " alt=" ">
                    <div class="iconser-head">Quality Assured </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- <div style="text-align: -webkit-center; font-family: Montserrat-Medium;">

        <div class="whaticon">
            <div class=" icon_holder ">
                <img itemprop="image " class="small-icons " src="/assets/images/img/customer-first-icon.png " alt=" ">
                <div class="icon-head">Customer First</div>
            </div>
            <div class="icon_holder ">
                <img itemprop="image " class="small-icons " src="/assets/images/img/support-icon.png " alt=" ">
                <div class="icon-head">Support</div>
            </div>
            <div class="icon_holder ">
                <img itemprop="image " class="small-icons " src="/assets/images/img/24hours-icon.png " alt=" ">
                <div class="icon-head">24/7 Service</div>
            </div>
            <div class="icon_holder ">
                <img itemprop="image " class="small-icons " src="/assets/images/img/quality-icon.png " alt=" ">
                <div class="icon-head">Quality Assured</div>
            </div>
        </div>
    </div> -->


<div class=" foto-bigser ">
    <div class="whatwedoser">
        <h2>Our Services</h2>
    </div>
    <div class=" careerhead2">
        <p>Well Care prides itself on having a medical team which is equipped with the skills and knowledge of the latest medical advancements which will satisfy both the short and long term needs of all our clients. All our staff here at Well Care undergo
            thorough, up-to-date training so that they are competent and can deliver the very best care to our client</p>
    </div>
    <div class="sermain">
        <button class="horse-bidcareer" routerLink="/contact">CONTACT US</button>
    </div>
</div>

<div style="background-color: #eee; ">
    <div class="container">
        <div>
            <div class="extensive">
                <h3>Our Extensive Background Checks</h3>
            </div>
            <div class="servicejoint">
                <div class="col-lg-6  col-md-12 col-sm-12">
                    <div class="liul">
                        <ul>
                            <li>
                                <div>
                                    DBS Check
                                </div>
                            </li>
                            <li>
                                <div>
                                    Right to work in the UK check
                                </div>
                            </li>
                            <li>
                                <div>
                                    Identity check
                                </div>
                            </li>
                            <li>
                                <div>
                                    Two reference (employment and professional/personal) verification
                                </div>
                            </li>
                            <li>
                                <div>
                                    Residential address verification
                                </div>
                            </li>
                            <li>
                                <div>
                                    NMC register (if applicable)
                                </div>
                            </li>
                            <li>
                                <div>
                                    General search
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6  col-md-12 col-sm-12 iconmiddle">
                    <div class="iconlast">
                        <img width="100%" src="/assets/images/img/servicepngimg.png" alt="">
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>